import { useState, useEffect } from 'react';
import { isLanguageSet } from '@/i18n';
import LanguageSelect from '@/pages/LanguageSelect';

const LanguageGate = ({ children }) => {
  const [showLanguageSelect, setShowLanguageSelect] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    // Check if language has been set
    const hasLanguage = isLanguageSet();
    setShowLanguageSelect(!hasLanguage);
    setIsChecking(false);
  }, []);

  const handleLanguageSelected = () => {
    setShowLanguageSelect(false);
    // Force a page reload to ensure all components pick up the new language
    window.location.reload();
  };

  // Show loading while checking
  if (isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#08172F]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#FFD700]"></div>
      </div>
    );
  }

  // Show language selection if not set
  if (showLanguageSelect) {
    return <LanguageSelect onComplete={handleLanguageSelected} />;
  }

  // Render children (the rest of the app)
  return children;
};

export default LanguageGate;
